import React, { FC, useState, forwardRef, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { MainReducerState } from '../../store/reducers';
import { connect } from 'react-redux';
import {
    OrganizationsState,
    search as searchOrganizations,
} from '../../store/actions/organizations';
import { SelectProps } from 'antd/lib/select';
import { Organization } from '../../store/api/apiTypes';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { OrganizationListPayload } from '../../store/api/organizations';

interface OrganizationFilterSelectProps {
    onChange?: (value: any) => void;
    multi?: boolean;
    organizations: OrganizationsState;
    search: typeof searchOrganizations.trigger;
    size?: SizeType;
    value ?: string[];
    setValue ?: any;
    initialValue ?: Organization[];
    filters ?: OrganizationListPayload;
}

const OrganizationFilterSelect: FC<OrganizationFilterSelectProps> = forwardRef((props, ref: any) => {

    const {onChange, organizations, search, multi, size, filters} = props;
    const [ value, setValue ] = useState<any>();
    const [ initialValue, setInitialValue ] = useState<Organization[]>([]);

    useEffect(() => {
        if (props.initialValue) {
            setValue(props.initialValue.map((a) => a.id));
            setInitialValue(props.initialValue);
            if (onChange) { onChange(props.initialValue.map((a) => a.id || a)); }
        } else {
            setValue([]);
            setInitialValue([]);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onFocus: SelectProps<Organization['id']>['onFocus'] = () => {
        search({
            search: '',
            pageSize: 15,
            ...filters,
        });
    };

    const onSearch: SelectProps<Organization['id']>['onSearch'] = (newValue) => {
        search({
            search: newValue,
            pageSize: 15,
            ...filters,
            throttling: 250,
        });
    };

    const onChangeSelect: SelectProps<Organization['id']>['onChange'] = (newValue) => {
        setValue(newValue);
        if (onChange) {onChange(newValue); }
    };

    return (
        <Select
            mode={(multi) ? 'multiple' : undefined}
            size={size}
            ref={ref}
            showSearch
            value={value}
            placeholder="Recherchez un client"
            notFoundContent={organizations.search.loading ? <Spin size="small" /> : null}
            filterOption={false}
            onSearch={onSearch}
            onChange={onChangeSelect}
            onFocus={onFocus}
            allowClear
            style={{ width: '100%' }}
        >
            {
                [
                    ...initialValue, // Display initial value
                    ...organizations.search.data.items.filter((a) => !initialValue.map((b) => b.id).includes(a.id)), // Search items, excluding initial value
                ].map((organization) => (
                <Select.Option value={organization.id} key={organization.id}>{organization.name}</Select.Option>
            ))}
        </Select>
    );

});

OrganizationFilterSelect.defaultProps = {
    multi: false,
    size: 'small',
};

const mapStateToProps = (state: MainReducerState) => ({
    organizations: state.organizations,
});

export default connect(
    mapStateToProps,
    {
        search: searchOrganizations.trigger,
    },
    null,
    { forwardRef: true },
)(OrganizationFilterSelect);
